<div class="px-4 standalone-item">
  <ng-container *ngComponentOutlet="widget.component; injector: widget.injector"></ng-container>
</div>
